import { api } from "./api";

export const storeContactUs = (first_name, mobile, email, message, budget) => {
  const params = {
    first_name: first_name,
    mobile: mobile,
    email: email,
    message: message,
    budget: budget,
  };
  return api.post(`/api/common/store-contact-us`, JSON.stringify(params));
};
